<template>
  <div class="athlete-page">
    <div class="page-toolbar">
      <div class="toolbar-left">
        <a-input v-model="query.keyword" placeholder="搜索姓名 / 手机号" allow-clear style="width:200px;" @pressEnter="loadData" @change="query.keyword || loadData()">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-select v-model="query.userRoleType" allow-clear placeholder="身份" style="width:120px;" @change="loadData">
          <a-select-option :value="1">运动员</a-select-option>
          <a-select-option :value="2">领队</a-select-option>
        </a-select>
        <a-select v-model="query.verified" allow-clear placeholder="认证状态" style="width:130px;" @change="loadData">
          <a-select-option :value="2">官方认证</a-select-option>
          <a-select-option :value="1">已认证</a-select-option>
          <a-select-option :value="0">未认证</a-select-option>
        </a-select>
        <a-select v-model="query.status" allow-clear placeholder="账号状态" style="width:120px;" @change="loadData">
          <a-select-option :value="1">正常</a-select-option>
          <a-select-option :value="0">已禁用</a-select-option>
        </a-select>
        <a-button type="primary" icon="search" @click="loadData">查询</a-button>
      </div>
      <div class="toolbar-right">
        <a-button v-if="isAdmin" type="primary" icon="plus" @click="openEdit(null)">新增运动员</a-button>
        <span class="total-tip" style="margin-left:12px;">共 {{ total }} 名{{ isAdmin ? '注册运动员' : '本赛事报名成员' }}</span>
      </div>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading"
      :pagination="pagination" @change="handleTableChange" size="middle">
      <span slot="avatar" slot-scope="text, record">
        <a-avatar :src="record.avatarUrl" :style="avatarStyle(record)">
          {{ (record.realName || record.nickname || record.memberName || '运')[0] }}
        </a-avatar>
      </span>
      <span slot="name" slot-scope="text, record">
        <div class="cell-name">{{ record.realName || record.memberName || '未填写' }}</div>
        <div class="cell-sub">{{ record.nickname || (record.appUserId ? '微信用户' : '预录成员') }}<span v-if="record.jiangkNo" style="margin-left:6px;">· {{ record.jiangkNo }}</span></div>
      </span>
      <span slot="verified" slot-scope="text, record">
        <template v-if="record.authStatus === 2">
          <a-tag color="gold">★ 官方认证</a-tag>
        </template>
        <template v-else-if="record.authStatus === 1">
          <a-tag color="green">实名认证</a-tag>
        </template>
        <template v-else>
          <a-tag color="orange">未认证</a-tag>
        </template>
      </span>
      <span slot="role" slot-scope="text, record">
        <a-tag :color="roleColor(record.userRoleType)">{{ roleText(record.userRoleType) }}</a-tag>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag :color="record.status === 1 ? 'green' : 'red'">{{ record.status === 1 ? '正常' : '已禁用' }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="openDetail(record)">详情</a>
        <template v-if="isAdmin">
          <a-divider type="vertical" />
          <a @click="openEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除该运动员吗？" @confirm="handleDelete(record)">
            <a style="color:#FF4D4F;">删除</a>
          </a-popconfirm>
        </template>
        <template v-else-if="record.status === 1">
          <a-divider type="vertical" />
          <a-popconfirm title="确定禁用该账号吗？" @confirm="toggleStatus(record, 0)">
            <a style="color:#FF4D4F;">禁用</a>
          </a-popconfirm>
        </template>
      </span>
    </a-table>

    <!-- 详情抽屉 -->
    <a-drawer :visible="detailVisible" title="运动员档案" placement="right" width="440" @close="detailVisible = false">
      <div v-if="detail">
        <div class="detail-head">
          <a-avatar :src="detail.avatarUrl" :size="64" :style="avatarStyle(detail)">
            {{ (detail.realName || detail.nickname || '运')[0] }}
          </a-avatar>
          <div class="detail-head-info">
            <div class="detail-name">{{ detail.realName || '未填写' }}</div>
            <div class="detail-nick">{{ detail.nickname || '微信用户' }}</div>
            <div>
              <a-tag :color="detail.idCardNo ? 'green' : 'orange'">{{ detail.idCardNo ? '已实名' : '未实名' }}</a-tag>
              <a-tag :color="detail.userRoleType === 2 || detail.userRoleType === 3 ? 'blue' : 'cyan'">{{ detail.userRoleType === 2 || detail.userRoleType === 3 ? '领队' : detail.userRoleType === 1 ? '运动员' : '未加入' }}</a-tag>
            </div>
          </div>
        </div>
        <div class="detail-body">
          <div class="detail-row"><span class="detail-label">手机号</span><span>{{ detail.mobile || '—' }}</span></div>
          <div class="detail-row"><span class="detail-label">身份证号</span><span>{{ detail.idCardNo || '—' }}</span></div>
          <div class="detail-row"><span class="detail-label">性别</span><span>{{ detail.gender || '—' }}</span></div>
          <div class="detail-row"><span class="detail-label">出生年份</span><span>{{ detail.birthYear || '—' }}</span></div>
          <div class="detail-row" v-if="detail.idCardFrontUrl || detail.idCardBackUrl">
            <span class="detail-label">证件照片</span>
            <span style="display:flex; gap:8px;">
              <img v-if="detail.idCardFrontUrl" :src="detail.idCardFrontUrl" style="width:90px; height:60px; object-fit:cover; border-radius:4px; cursor:pointer;" @click="previewFile(detail.idCardFrontUrl)" />
              <img v-if="detail.idCardBackUrl" :src="detail.idCardBackUrl" style="width:90px; height:60px; object-fit:cover; border-radius:4px; cursor:pointer;" @click="previewFile(detail.idCardBackUrl)" />
            </span>
          </div>
          <div class="detail-row"><span class="detail-label">居住地</span><span>{{ provinceText(detail) }}</span></div>
          <div class="detail-row"><span class="detail-label">身高</span><span>{{ detail.heightCm ? detail.heightCm + ' cm' : '—' }}</span></div>
          <div class="detail-row"><span class="detail-label">体重</span><span>{{ detail.weightKg ? detail.weightKg + ' kg' : '—' }}</span></div>
          <div class="detail-row"><span class="detail-label">服装尺码</span><span>{{ detail.clothingSize || '—' }}</span></div>
          <div class="detail-row"><span class="detail-label">参赛位置</span><span>{{ detail.racePosition || '—' }}</span></div>
          <div class="detail-row detail-column">
            <span class="detail-label">参赛经历</span>
            <span class="detail-content">{{ detail.participationHistory || '—' }}</span>
          </div>
          <div class="detail-row"><span class="detail-label">注册时间</span><span>{{ formatDateTime(detail.createTime) }}</span></div>
        </div>
        <div class="detail-foot">
          <a-popconfirm v-if="detail.status === 1" title="确定禁用该账号吗？" @confirm="toggleStatus(detail, 0)">
            <a-button type="danger" block>禁用账号</a-button>
          </a-popconfirm>
          <a-popconfirm v-else title="确定恢复该账号吗？" @confirm="toggleStatus(detail, 1)">
            <a-button type="primary" block>恢复账号</a-button>
          </a-popconfirm>
        </div>
      </div>
    </a-drawer>
    <!-- 新增/编辑弹窗 -->
    <a-modal :visible="editVisible" :title="editForm.id ? '编辑运动员' : '新增运动员'" width="640" @ok="submitEdit" @cancel="editVisible = false" :confirmLoading="saving">
      <a-form-model :model="editForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="头像">
          <div style="display:flex; align-items:center; gap:12px;">
            <a-avatar :src="editForm.avatarUrl" :size="48">{{ (editForm.realName || '运')[0] }}</a-avatar>
            <a-upload :customRequest="handleAvatarUpload" :showUploadList="false" accept=".jpg,.jpeg,.png">
              <a-button size="small">上传头像</a-button>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item label="桨刻号"><a-input v-model="editForm.jiangkNo" disabled placeholder="自动生成" /></a-form-model-item>
        <a-form-model-item label="姓名" required><a-input v-model="editForm.realName" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="性别">
              <a-select v-model="editForm.gender" allow-clear placeholder="选择性别">
                <a-select-option value="男">男</a-select-option>
                <a-select-option value="女">女</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="手机号"><a-input v-model="editForm.mobile" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="出生日期">
              <a-date-picker v-model="editForm.birthDate" placeholder="选择出生日期" style="width:100%;" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :allow-clear="true" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="身份证号"><a-input v-model="editForm.idCardNo" /></a-form-model-item>
        <a-form-model-item label="身份证照片">
          <div style="display:flex; gap:12px; align-items:center; flex-wrap:wrap;">
            <div style="display:flex; flex-direction:column; gap:6px;">
              <img v-if="editForm.idCardFrontUrl" :src="resolveFile(editForm.idCardFrontUrl)" style="width:120px; height:80px; object-fit:cover; border-radius:6px;" />
              <a-upload :customRequest="handleIdCardUpload" :data="{ side: 'front' }" :showUploadList="false" accept=".jpg,.jpeg,.png">
                <a-button size="small">{{ editForm.idCardFrontUrl ? '更换正面' : '上传正面' }}</a-button>
              </a-upload>
            </div>
            <div style="display:flex; flex-direction:column; gap:6px;">
              <img v-if="editForm.idCardBackUrl" :src="resolveFile(editForm.idCardBackUrl)" style="width:120px; height:80px; object-fit:cover; border-radius:6px;" />
              <a-upload :customRequest="handleIdCardUpload" :data="{ side: 'back' }" :showUploadList="false" accept=".jpg,.jpeg,.png">
                <a-button size="small">{{ editForm.idCardBackUrl ? '更换反面' : '上传反面' }}</a-button>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="身高(cm)"><a-input-number v-model="editForm.heightCm" :min="100" :max="250" style="width:100%;" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="体重(kg)"><a-input-number v-model="editForm.weightKg" :min="30" :max="200" style="width:100%;" /></a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="服装尺码"><a-input v-model="editForm.clothingSize" placeholder="如 S/M/L/XL" /></a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="居住地">
              <a-cascader v-model="editForm.region" :options="regionOptions" placeholder="选择省/市/区" style="width:100%;" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="个人简介"><a-textarea v-model="editForm.bio" :rows="2" placeholder="选填" /></a-form-model-item>
        <a-form-model-item label="参赛经历">
          <a-textarea v-model="editForm.participationHistory" :rows="3" placeholder="过往参赛及成绩" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import chinaPca from '@/utils/china-pca'
import { deleteDragonAthlete, getDragonAthleteDetail, getDragonAthleteList, saveDragonAthlete, updateDragonAthleteStatus } from '@/api'
import { formatDateTime } from '@/utils/date'
import request from '@/utils/request'

export default {
  name: 'AthleteManage',
  data() {
    return {
      isAdmin: false,
      birthYearOptions: (() => {
        const now = new Date().getFullYear()
        const arr = []
        for (let y = now; y >= now - 100; y -= 1) arr.push(y)
        return arr
      })(),
      regionOptions: Object.keys(chinaPca).map(province => ({
        value: province,
        label: province,
        children: Object.keys(chinaPca[province] || {}).map(city => ({
          value: city,
          label: city,
          children: (chinaPca[province][city] || []).map(district => ({ value: district, label: district }))
        }))
      })),
      query: { keyword: undefined, userRoleType: undefined, verified: undefined, status: undefined },
      data: [],
      total: 0,
      loading: false,
      detailVisible: false,
      detail: null,
      editVisible: false,
      editForm: {},
      saving: false,
      pagination: { current: 1, pageSize: 10, total: 0 },
      columns: [
        { title: '用户', key: 'user', width: 180, scopedSlots: { customRender: 'avatar' } },
        { title: '赛事', dataIndex: 'eventTitle', customRender: text => text || '—' },
        { title: '队伍', dataIndex: 'teamName', customRender: text => text || '—' },
        { title: '手机号', dataIndex: 'mobile', width: 120 },
        { title: '身份', dataIndex: 'userRoleType', width: 80, scopedSlots: { customRender: 'role' } },
        { title: '认证', dataIndex: 'authStatus', width: 110, scopedSlots: { customRender: 'verified' } },
        { title: '居住地', dataIndex: 'residenceCity', customRender: (text, r) => `${r.residenceProvince || ''}${r.residenceCity || ''}`.slice(0, 12) || '—' },
        { title: '注册时间', dataIndex: 'createTime', customRender: text => formatDateTime(text) },
        { title: '状态', dataIndex: 'status', width: 80, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 150, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    avatarStyle(record) {
      return { background: this.avatarColor(record), color: '#fff', fontSize: '16px' }
    },
    avatarColor(record) {
      const name = record.realName || record.nickname || '运'
      const colors = ['#4ECDC4', '#5B8DEF', '#F5A623', '#9254DE', '#52C41A', '#FF7875']
      let sum = 0
      for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i)
      return colors[sum % colors.length]
    },
    roleText(type) {
      if (type === 2 || type === 3) return '领队'
      if (type === 1) return '运动员'
      return '未加入'
    },
    roleColor(type) {
      if (type === 2 || type === 3) return 'blue'
      if (type === 1) return 'cyan'
      return 'default'
    },
    provinceText(detail) {
      return [detail.residenceProvince, detail.residenceCity, detail.residenceDistrict].filter(Boolean).join('') || '—'
    },
    formatDateTime,
    loadData() {
      this.loading = true
      getDragonAthleteList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: this.query.keyword,
        userRoleType: this.query.userRoleType,
        verified: this.query.verified,
        status: this.query.status
      }).then(res => {
        this.data = res.data.list
        this.total = res.data.total
        this.isAdmin = res.data.scope === 'all'
        this.pagination.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    openDetail(record) {
      getDragonAthleteDetail({ id: record.id }).then(res => {
        this.detail = res.data
        this.detailVisible = true
      })
    },
    toggleStatus(record, status) {
      updateDragonAthleteStatus({ id: record.id, status }).then(() => {
        this.$message.success(status === 1 ? '账号已恢复' : '账号已禁用')
        this.loadData()
        if (this.detail && this.detail.id === record.id) {
          this.detail.status = status
        }
      })
    },
    openEdit(record) {
      if (record) {
        this.editForm = {
          id: record.id,
          realName: record.realName || '',
          mobile: record.mobile || '',
          idCardNo: record.idCardNo || '',
          gender: record.gender || undefined,
          birthYear: record.birthYear || undefined,
          birthDate: record.birthDate || (record.birthYear ? `${record.birthYear}-01-01` : null),
          avatarUrl: record.avatarUrl || '',
          jiangkNo: record.jiangkNo || '',
          bio: record.bio || '',
          idCardFrontUrl: record.idCardFrontUrl || '',
          idCardBackUrl: record.idCardBackUrl || '',
          verified: !!record.verified,
          region: [record.residenceProvince, record.residenceCity, record.residenceDistrict].filter(Boolean),
          residenceProvince: record.residenceProvince || '',
          residenceCity: record.residenceCity || '',
          residenceDistrict: record.residenceDistrict || '',
          heightCm: record.heightCm || undefined,
          weightKg: record.weightKg || undefined,
          clothingSize: record.clothingSize || '',
          participationHistory: record.participationHistory || ''
        }
      } else {
        this.editForm = {
          realName: '',
          mobile: '',
          idCardNo: '',
          gender: undefined,
          birthYear: undefined,
          birthDate: null,
          region: [],
          avatarUrl: '',
          jiangkNo: '',
          bio: '',
          idCardFrontUrl: '',
          idCardBackUrl: '',
          verified: false,
          residenceProvince: '',
          residenceCity: '',
          residenceDistrict: '',
          heightCm: undefined,
          weightKg: undefined,
          clothingSize: '',
          participationHistory: ''
        }
      }
      this.editVisible = true
    },
    previewFile(url) {
      if (url) window.open(url, '_blank')
    },
    handleIdCardUpload({ file, data, onSuccess, onError }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('businessType', 'user_idcard')
      request({
        url: '/dragonboat/event/file/upload',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        const fileUrl = res.data.fileUrl
        if (data && data.side === 'back') {
          this.editForm.idCardBackUrl = fileUrl
        } else {
          this.editForm.idCardFrontUrl = fileUrl
        }
        this.$message.success('证件照已上传')
        onSuccess(res.data)
      }).catch(err => {
        this.$message.error((err && err.msg) || '上传失败')
        onError(err)
      })
    },
    resolveFile(url) {
      if (!url) return ''
      return url
    },
    handleAvatarUpload({ file, onSuccess, onError }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('businessType', 'user_avatar')
      request({
        url: '/dragonboat/event/file/upload',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        this.editForm.avatarUrl = res.data.fileUrl
        this.$message.success('头像已上传')
        onSuccess(res.data)
      }).catch(err => {
        this.$message.error((err && err.msg) || '上传失败')
        onError(err)
      })
    },
    submitEdit() {
      const birthDate = this.editForm.birthDate
      if (birthDate) {
        this.editForm.birthYear = Number(String(birthDate).slice(0, 4))
      }
      const region = this.editForm.region || []
      this.editForm.residenceProvince = region[0] || ''
      this.editForm.residenceCity = region[1] || ''
      this.editForm.residenceDistrict = region[2] || ''
      if (!this.editForm.realName) {
        this.$message.warning('请填写姓名')
        return
      }
      this.saving = true
      saveDragonAthlete(this.editForm).then(() => {
        this.$message.success(this.editForm.id ? '运动员资料已更新' : '运动员已建档')
        this.editVisible = false
        this.loadData()
      }).finally(() => {
        this.saving = false
      })
    },
    handleDelete(record) {
      deleteDragonAthlete({ id: record.id }).then(() => {
        this.$message.success('已删除')
        this.loadData()
      })
    }
  }
}
</script>

<style scoped>
.athlete-page { min-height: 100vh; }

.page-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-left {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.total-tip {
  color: #7A8A9A;
  font-size: 13px;
}

.cell-name {
  font-weight: 600;
  color: #16232F;
}

.cell-sub {
  font-size: 12px;
  color: #A8B8C2;
}

.detail-head {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E4EDF2;
  margin-bottom: 16px;
}

.detail-name {
  font-size: 18px;
  font-weight: 700;
  color: #16232F;
}

.detail-nick {
  font-size: 13px;
  color: #A8B8C2;
  margin-bottom: 6px;
}

.detail-body { margin-bottom: 20px; }

.detail-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px dashed #E4EDF2;
  font-size: 14px;
}

.detail-row.detail-column {
  flex-direction: column;
  gap: 6px;
}

.detail-label {
  width: 90px;
  color: #7A8A9A;
  flex-shrink: 0;
}

.detail-content {
  color: #2C3A4B;
  line-height: 1.6;
}
</style>
